module.exports = __webpack_public_path__ + "img/Organization_default.d9f36ec2.png";